import styled from 'styled-components'

export const MapboxContainer = styled.div`
  position: absolute;
  top: 60px;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;

  .mapboxgl-ctrl-group {
    position: fixed;
    border-radius: ${(p) => p.theme.decoration.borderRadius.default};
    top: 450px;
    right: 10px;
  }
`
